import React, { useState } from "react";

import Button from "../Button/Button";
import { BootstrapModal } from "../BootstrapModal/Modal";
import { InputField1 } from "../InputField1/InputField1";

import { CgClose } from "react-icons/cg";
import { SimpleTextArea } from "../SimpleTextArea/SimpleTextArea";
import { DataPicker } from "../DataPicker/DataPicker";
import { useEffect } from "react";
import { useUpdateMeetingSummary } from "../../hooks/useManagement";
import { formatDate } from "../../utils/formatDate";
import { SelectMulti } from "../MultiSelect/MultiSelect";
import { useRecoilValue } from "recoil";
import { MeetingItem } from "../../shared/meetingItem";

export const UpdateMeetingModal = ({
  handleClose,
  show,
  item,
  customerResponsibleOptions,
}) => {
  const [data, setData] = useState({
    subject: "",
    description: "",
    date: "",
    meeting_id: "",
    target_user: [],
  });
  const itemm = useRecoilValue(MeetingItem);
  useEffect(() => {
    if (item) {
      setData({
        ...data,
        subject: item?.SubjectMeeting,
        meeting_id: item?.IdMeeting,
        date: item?.DateMeeting,
        description: item?.DescriptionMeeting,
      });
    }
  }, [item, show]);
  const { mutateAsync: UpdateMeeting, isLoading } = useUpdateMeetingSummary();
  const handleUpdate = async (data) => {
    await UpdateMeeting(data);
  };

  const users = item?.users.map(
    (user) =>
      (user.FirstName ? user.FirstName : "") +
      " " +
      (user.LastName ? user.LastName : "")
  );
  return (
    <BootstrapModal
      modaltitle="ویرایش صورت جلسه"
      handleClose={handleClose}
      show={show}
      size="lg"
      closebutton={
        <Button style={{ width: "40px", border: "none" }} onclick={handleClose}>
          <CgClose />
        </Button>
      }
    >
      <InputField1
        type="text"
        name="MeetingSubject"
        label="عنوان صورت جلسه"
        required
        placeholder="عنوان صورت جلسه"
        value={data?.subject}
        onChange={(e) => setData({ ...data, subject: e.target.value })}
      />
      <InputField1 label="اعضا صورت جلسه" value={users} readonly />
      <SelectMulti
        label="افزودن عضو جدید"
        res={customerResponsibleOptions}
        onChange={(e) =>
          setData({
            ...data,
            target_user: Array.isArray(e) ? e.map((x) => x.value) : [],
          })
        }
      />
      <DataPicker
        onChange={(e) => setData({ ...data, date: formatDate(e) })}
        label={`تاریخ صورت جلسه (تاریخ فعلی:${item?.DateMeeting})`}
      />
      <SimpleTextArea
        label="متن صورت جلسه"
        placeholder="متن صورت جلسه"
        rows="5"
        value={data?.description}
        onChange={(e) => setData({ ...data, description: e.target.value })}
      />
      <Button
        bgColor="#0062FF"
        color="#fff"
        small="100px"
        size="14px"
        onclick={() => {
          handleUpdate(data);
          handleClose();
        }}
      >
        ویرایش
      </Button>
    </BootstrapModal>
  );
};

export default UpdateMeetingModal;
